import { BASE_URL } from "../constants";
import { LogEntity } from "../entities/LogEntity";
import FetchUtils from "../utils/fetch";

class LogService {
    static async GetAllLogs(start_date: string, end_date: string): Promise<LogEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/logs?start_date=${start_date}&end_date=${end_date}`);
        if (resp.status != 200) { throw resp.message }

        const data: LogEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push({
                date: resp.data[i].date,
                request: resp.data[i].request,
                response: resp.data[i].response,
            })
        }

        return data;
    }
}

export { LogService };